module.exports = __webpack_public_path__ + "static/SW-blau-13fbc358cf2710bb0d6d01ee0dfc70e9.svg";